/**
 * ATTENTION! This file is auto-generated for the 'activity' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { ActivityThreadRepository } from '../server/repositories/ActivityThreadRepository';
import type { ActivityEventRepository } from '../server/repositories/ActivityEventRepository';
import type { ActivityUserStateRepository } from '../server/repositories/ActivityUserStateRepository';
import type { ActivityPinRepository } from '../server/repositories/ActivityPinRepository';
import type { DmConversationRepository } from '../server/repositories/DmConversationRepository';
import type { ProjectTaskRepository } from '../server/repositories/ProjectTaskRepository';
import type { TelegramThreadLinkRepository } from '../server/repositories/TelegramThreadLinkRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","meta","getInstance","columns","filters"];

type ActivityThreadRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ActivityThreadRepository>;
export function useActivityThreadRepository(): ActivityThreadRepositoryClient { return makeRepositoryProxy<ActivityThreadRepositoryClient>('activity::ActivityThreadRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useActivityThreadRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const activityThreadRepository = useActivityThreadRepository();

type ActivityEventRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ActivityEventRepository>;
export function useActivityEventRepository(): ActivityEventRepositoryClient { return makeRepositoryProxy<ActivityEventRepositoryClient>('activity::ActivityEventRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useActivityEventRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const activityEventRepository = useActivityEventRepository();

type ActivityUserStateRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ActivityUserStateRepository>;
export function useActivityUserStateRepository(): ActivityUserStateRepositoryClient { return makeRepositoryProxy<ActivityUserStateRepositoryClient>('activity::ActivityUserStateRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useActivityUserStateRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const activityUserStateRepository = useActivityUserStateRepository();

type ActivityPinRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ActivityPinRepository>;
export function useActivityPinRepository(): ActivityPinRepositoryClient { return makeRepositoryProxy<ActivityPinRepositoryClient>('activity::ActivityPinRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useActivityPinRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const activityPinRepository = useActivityPinRepository();

type DmConversationRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DmConversationRepository>;
export function useDmConversationRepository(): DmConversationRepositoryClient { return makeRepositoryProxy<DmConversationRepositoryClient>('activity::DmConversationRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDmConversationRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dmConversationRepository = useDmConversationRepository();

type ProjectTaskRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ProjectTaskRepository>;
export function useProjectTaskRepository(): ProjectTaskRepositoryClient { return makeRepositoryProxy<ProjectTaskRepositoryClient>('activity::ProjectTaskRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useProjectTaskRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const projectTaskRepository = useProjectTaskRepository();

type TelegramThreadLinkRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelegramThreadLinkRepository>;
export function useTelegramThreadLinkRepository(): TelegramThreadLinkRepositoryClient { return makeRepositoryProxy<TelegramThreadLinkRepositoryClient>('activity::TelegramThreadLinkRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelegramThreadLinkRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telegramThreadLinkRepository = useTelegramThreadLinkRepository();

type generateTelegramGroupLinkType = typeof import('../server/functions/generateTelegramGroupLink').generateTelegramGroupLink;
export const generateTelegramGroupLink: RpcFunctionClient<generateTelegramGroupLinkType> = makeFunctionProxy<generateTelegramGroupLinkType>('activity::generateTelegramGroupLink');

type getThreadTelegramLinksType = typeof import('../server/functions/getThreadTelegramLinks').getThreadTelegramLinks;
export const getThreadTelegramLinks: RpcFunctionClient<getThreadTelegramLinksType> = makeFunctionProxy<getThreadTelegramLinksType>('activity::getThreadTelegramLinks');

type removeTelegramThreadLinkType = typeof import('../server/functions/removeTelegramThreadLink').removeTelegramThreadLink;
export const removeTelegramThreadLink: RpcFunctionClient<removeTelegramThreadLinkType> = makeFunctionProxy<removeTelegramThreadLinkType>('activity::removeTelegramThreadLink');
